import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 1.6h3.2a.8.8 0 0 1 .8.8v12.8a.8.8 0 0 1-.8.8H.8a.8.8 0 0 1-.8-.8V2.4a.8.8 0 0 1 .8-.8H4V0h1.6v1.6h4.8V0H12zM1.6 6.4v8h12.8v-8zm1.6 3.2h4v3.2h-4z"
    }, null, -1)
  ])))
}
export default { render: render }